import { render } from "./Return.vue?vue&type=template&id=3e523a62&scoped=true"
import script from "./Return.vue?vue&type=script&lang=js"
export * from "./Return.vue?vue&type=script&lang=js"

import "./Return.vue?vue&type=style&index=0&id=3e523a62&scoped=true&lang=css"
import "./Return.vue?vue&type=style&index=1&id=3e523a62&lang=scss"
import "./Return.vue?vue&type=style&index=2&id=3e523a62&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e523a62"]])

export default __exports__